import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20Korean%20manhwa%20style%20illustration%2C%20dynamic%20character%20composition%20with%20vibrant%20warm%20colors%2C%20soft%20gradient%20background%20in%20cream%20and%20warm%20beige%20tones%2C%20stylized%20abstract%20comic%20panels%20floating%2C%20elegant%20artistic%20aesthetic%2C%20no%20text%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
          alt="韩漫屋 - 免费韩漫在线阅读平台"
          title="韩漫屋 - 免费韩漫,漫画大全,在线漫画,好看的韩国漫画"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full text-center px-6 md:px-10 pt-16">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight">
          发现你的下一部
          <br />
          心动韩漫
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
          韩漫屋汇集海量<strong>免费韩漫</strong>资源，每日更新热门<strong>漫画大全</strong>，
          为你精心挑选最<strong>好看的韩国漫画</strong>作品。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/romance"
            className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">5000+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">漫画作品</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">200万+</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">活跃读者</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">每日更新</div>
            <div className="text-xs md:text-sm text-white/60 mt-1">从不间断</div>
          </div>
        </div>
      </div>
    </section>
  );
}